// Set up your application entry point here...
// Polyfill for css focus-visible
// https://github.com/WICG/focus-visible
import "../node_modules/focus-visible/dist/focus-visible.min";

import * as Sentry from "@sentry/browser";
import Immutable from "immutable";
import installDevTools from "immutable-devtools";
import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";

import { version } from "../jsAppVersion";
import App from "./features/app";
import installNativeComms from "./nativeComms";
import configureStore from "./store/configureStore";
import templateToStoreConverter from "./store/templateToStoreConverter";
import sampleTemplate from "./templates/fictionTemplate";
import { createFromJS } from "./types";
import preprocessorQuery from "./utils/preprocessorQuery";

if (process.env.NODE_ENV === "production") {
  let dsn = null;
  let platform = null;

  if (preprocessorQuery.isDesktop()) {
    if (preprocessorQuery.isReadonly()) {
      dsn = "https://8bab53d128974b10a92c4c2cb818eb44@o348103.ingest.sentry.io/6000909";
      platform = "desktop-readonly";
    } else {
      dsn = "https://83d91998ad99428f933c6b49a8d4229b@o348103.ingest.sentry.io/2195674";
      platform = "desktop";
    }
  } else if (preprocessorQuery.isTablet()) {
    if (preprocessorQuery.isReadonly()) {
      dsn = "https://09d4724509f74be48f7098e9871b86ab@o348103.ingest.sentry.io/6000915";
      platform = "tablet-readonly";
    } else {
      dsn = "https://5e163340cbe24553b057fa0648d0ac83@o348103.ingest.sentry.io/5516934";
      platform = "tablet";
    }
  } else if (preprocessorQuery.isMobile()) {
    if (preprocessorQuery.isReadonly()) {
      dsn = "https://25bd7cf30c45476dab3d3eb73b3865db@o348103.ingest.sentry.io/6000916";
      platform = "mobile-readonly";
    } else {
      dsn = "https://b88ee70dfcb04cee9f015e31d5344beb@o348103.ingest.sentry.io/5516933";
      platform = "mobile";
    }
  }

  const release = `aeon-timeline-js-${platform}@${version}`;
  Sentry.init({
    dsn,
    release
  });
}

if (process.env.NODE_ENV !== "production") {
  installDevTools(Immutable);
}

const useDataTemp = templateToStoreConverter(sampleTemplate);

const initialState = createFromJS.TimelineRecord(useDataTemp);
const store = configureStore(initialState);

installNativeComms(store);

render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById("app")
);
